import React, { useEffect, useState } from "react";
import { Autocomplete } from "@mui/lab";
import { useForm } from "react-hook-form";
import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useLanguageContext } from "../../../Context/LanguageContext";
import FeedBackAction from "../../../Actions/FeedBackAction";
import feedBackStore from "../../../Stores/FeedBackStore";
import FeedBackConstant from "../../../Constants/FeedBackConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import AppConstants from "../../../Constants/AppConstants";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
}));
const labelStyle = {
  fontSize: "14px",
  backgroundColor: "white",
};
export default function InspectionFeedBack({
  equipmentDetails,
  feedBackCallBack,
  setShowFeedBackPop,
  setInputFeedBackValue,
  isInspectionRequired,
  feedBackRequiredError,
  handleBlurFeedBack,
}) {
  const classes = useStyles();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const {
    register,
    setFocus,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });
  const [selectedFeedBack, setSelectedFeedBack] = useState("");
  const [FeedBackList, setFeedBackList] = useState([]);
  const [inputFeedBack, setInputFeedBack] = useState("");

  const handleSubmitFeedBack = (e) => {
    e.preventDefault();
    feedBackCallBack(
      selectedFeedBack
        ? FeedBackList.filter(
            (item) => item.bezeichnung === selectedFeedBack
          )[0]
        : { id: 0, bezeichnung: inputFeedBack }
    );
  };

  const getFeedBackList = () => {
    setGlobalSpinner(true);
    FeedBackAction.getFeedBackByEqGrp(equipmentDetails.anlagegruppeID);
  };

  useEffect(() => {
    getFeedBackList();
    function getFeedBackResultSuccess() {
      const res = feedBackStore.getResult();
      if (res.length > 0) {
        setFeedBackList(res);
      } else {
        setFeedBackList([]);
      }
      setGlobalSpinner(false);
    }
    function getFeedBackResultFailure() {
      const res = feedBackStore.getResult();
      setGlobalSpinner(false);
    }
    feedBackStore.addChangeListener(
      FeedBackConstant.GET_FEEDBACK_LIST_SUCCESS,
      getFeedBackResultSuccess
    );
    feedBackStore.addChangeListener(
      FeedBackConstant.GET_FEEDBACK_LIST_FAILURE,
      getFeedBackResultFailure
    );
    return () => {
      feedBackStore.removeChangeListener(
        FeedBackConstant.GET_FEEDBACK_LIST_SUCCESS,
        getFeedBackResultSuccess
      );
      feedBackStore.removeChangeListener(
        FeedBackConstant.GET_FEEDBACK_LIST_FAILURE,
        getFeedBackResultFailure
      );
    };
  }, []);

  function hanldeBlur() {
    if (inputFeedBack === "") {
      setInputFeedBackValue("");
      handleBlurFeedBack("");
    } else {
      const _temp = FeedBackList.filter(
        (item) => item.bezeichnung === inputFeedBack
      )[0];
      setInputFeedBackValue(
        _temp
          ? _temp
          : { id: AppConstants.DEFAULT_GUID, bezeichnung: inputFeedBack }
      );
      handleBlurFeedBack(_temp);
    }
  }
  return (
    <div className="row ml-0">
      <Autocomplete
        freeSolo
        id="feedback"
        className="titleAutocomplete"
        value={selectedFeedBack}
        fullWidth
        options={FeedBackList.map((item) => item.bezeichnung)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={localization.feedBacklabel}
            error={feedBackRequiredError}
            helperText={feedBackRequiredError && localization.feedBackRequired}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ style: labelStyle }}
            {...register("feedback", {
              required: localization.feedBackRequired,
            })}
            InputProps={{ ...params.InputProps }}
          />
        )}
        onChange={(e, newValue) => {
          setSelectedFeedBack(newValue);
        }}
        onBlur={hanldeBlur}
        inputValue={inputFeedBack}
        onInputChange={(event, newInputValue) => {
          setInputFeedBack(newInputValue);
        }}
      />
    </div>
  );
}
